import { RoomV2Entity, RoomV2EntityRaw } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomsListResponseDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomsListResponseDTO.validationSchema()
  );

  constructor(readonly data: RoomsListResponseRaw) {
    JsonSchemaValidator.assert(RoomsListResponseDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["rooms"],
      properties: {
        rooms: {
          type: "array",
          minItems: 0,
          maxItems: Number.MAX_SAFE_INTEGER,
          items: RoomV2Entity.schema()
        }
      },
      additionalProperties: false
    };
  }
}

export interface RoomsListResponseRaw {
  rooms: RoomV2EntityRaw[];
}
